import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatAutocomplete, MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { BehaviorSubject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

@UntilDestroy()
@Component({
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
  ],
  selector: 'customer-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SearchComponent {
  @Input() dialogMode = false;
  @Input() autofocus = false;
  @Input() debounce = 300;
  @Input() placeholder = 'Search';
  @Input() set query(value: string) {
    this.innerQueryChange$.next(value);
  }
  get query() {
    return this.innerQueryChange$?.value || '';
  }
  @Input() autocomplete?: MatAutocomplete;

  @ViewChild('search', { read: ElementRef }) set input(el: ElementRef<HTMLInputElement>) {
    if (this.autofocus || this.query) {
      el.nativeElement.focus();
    }

    this.innerQueryChange$.pipe(
      untilDestroyed(this),
    ).subscribe((query) => {
      if (query) {
        el.nativeElement.focus();
      }
    });
  }

  readonly innerQueryChange$ = new BehaviorSubject<string>('');

  @Output() readonly queryChange = this.innerQueryChange$.pipe(debounceTime(this.debounce));
  @Output() readonly clearQuery = new EventEmitter();
}
